import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import {classify} from 'src/utils/classify';
import css from './EmptyChartComponent.css';


type Props = {
  title?: string;
  description?: string;
  classNames?: {
    wrapper?: string;
    description?: string;
  };
};

export const EmptyChartComponent = ({
  title = '',
  description = '',
  classNames,
}: Props) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const titleText = title
    ? title
    : `${t(
        'Your_chart_is_waiting_for_data',
        'Your chart is waiting for data',
      )}!`;
  const descriptionText = description
    ? description
    : `${t(
        'Once_data_is_available_youll_see_insights_here_Try_adjusting_filters_or_selecting_a_different_time_range',
        'Once data is available, you’ll see insights here. Try adjusting filters or selecting a different time range',
      )}.`;
  return (
    <EmptyState
      classNames={{
        wrapper: classify(css.emptyDataWrapper, classNames?.wrapper),
        description: classify(
          css.emptyDataDescription,
          classNames?.description,
        ),
      }}
      imageVariant="chart"
      title={titleText}
      description={descriptionText}
    />
  );
};
